import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const payoutStatusChangedV1Schema = eventEnvelopeSchema.extend({
  payoutId: z.string().min(1).max(256),
  charityStackPayoutId: z.string().min(1).max(256).optional(),
  status: z.string().min(1).max(64),
  previousStatus: z.string().min(1).max(64).optional(),
  amountCents: z.number().int().optional(),
  currency: z.string().length(3).optional(),
  paymentProcessor: z.string().min(1).max(64).optional(),
  merchantName: z.string().min(1).max(256).optional(),
});

export type PayoutStatusChangedV1 = z.infer<typeof payoutStatusChangedV1Schema>;

export const PAYOUT_STATUS_CHANGED_V1_DETAIL_TYPE =
  'payout.status-changed.v1' as const;
